export default __webpack_public_path__ + "static/media/image-board-study-pyramid-n-w.648fe845.webp";